import {Form, Input} from 'antd';
import {FormInstance} from 'antd/es/form';
import {FormListFieldData} from 'antd/es/form/FormList';
import cn from 'classnames';
import React, {FC} from 'react';

import {CustomSelect} from 'components/form/inputs/custom-select';
import {LargeStringInput} from 'components/form/inputs/large-string-input';
import {IReportPropertiesFormState} from 'components/report-configuration/tabs/report-properties-settings';
import {
    IDocumentUploadTemplateData,
} from 'store/slices/document-upload-template/document-upload-template-slice-type';

import {EWatcherFieldFlag} from '../../../../../report-configuration/hooks/use-form-fields-manager';
import {
    SETTING_TEMPLATE_TRANSFER_TARGET_FIELD_TYPE,
    SETTING_TEMPLATE_TRANSFER_TARGET_FORM_DATA_KEY,
    ESettingTemplateTransferTargetFormFields,
} from '../../constants/setting-template-transfer-target/setting-template-transfer-target';
import {FormatSettingsModalOpener} from '../format-settings-modal-opener/format-settings-modal-opener';
import './setting-template-transfer-target-fields.less';

export interface ISettingTemplateTransferTargetProps {
  form: FormInstance;
  formState: IReportPropertiesFormState;
  fields: FormListFieldData[];
  checkWatcherFlag: (
    index: number,
    key: string,
    flag: EWatcherFieldFlag
  ) => boolean;
  checkArrayIndependentWatcherFlag?: (
    key: string,
    flag: EWatcherFieldFlag
  ) => boolean;
  documentUploadTemplate?: IDocumentUploadTemplateData;
}
export const SettingTemplateTransferTargetFields: FC<ISettingTemplateTransferTargetProps> = ({
    form,
    formState,
    fields,
    checkWatcherFlag,
    documentUploadTemplate,
}: ISettingTemplateTransferTargetProps) => (
    <div className={cn('form-list')}>
        {fields.map(field => (
            <div
                key={field.key}
                className={cn('form-list__items')}
            >
                <Form.Item
                    style={{width: 220}}
                    label="Атрибут"
                    rules={[{required: true}]}
                    name={[field.name, ESettingTemplateTransferTargetFormFields.targetField]}
                >
                    <Input
                        disabled
                        autoComplete="off"
                        placeholder="Введите атрибут"
                    />
                </Form.Item>
                <Form.Item
                    label="Описание"
                    style={{width: 220}}
                    name={[field.name, ESettingTemplateTransferTargetFormFields.description]}
                    rules={[{required: true}]}
                >
                    <Input
                        autoComplete="off"
                        placeholder="Введите описание"
                        disabled={checkWatcherFlag(
                            field.name,
                            ESettingTemplateTransferTargetFormFields.description,
                            EWatcherFieldFlag.isDisabled,
                        )}
                    />
                </Form.Item>
                <Form.Item
                    label="Поле исходной таблицы"
                    name={[field.name, ESettingTemplateTransferTargetFormFields.sourceField]}
                    style={{width: 220}}
                    rules={[{
                        required: !checkWatcherFlag(
                            field.name,
                            ESettingTemplateTransferTargetFormFields.sourceField,
                            EWatcherFieldFlag.isDisabled,
                        ),
                    }]}
                    validateTrigger="onFocuse"
                >
                    <CustomSelect
                        settings={{
                            showSearch: true,
                            placeholder: 'Выберите тип поля',
                            url: `valueLists/DATABASE_TABLE_COLUMNS?sublistCode=${
                                form?.getFieldValue(ESettingTemplateTransferTargetFormFields.SOURCE_TABLE)
                                || documentUploadTemplate?.attribute1
                            }&sublistId=1`,
                            labelPath: 'lookupCode',
                            isClearable: true,
                            isDisabled: checkWatcherFlag(field.name,
                                ESettingTemplateTransferTargetFormFields.sourceField,
                                EWatcherFieldFlag.isDisabled),
                            valuePath: 'lookupCode',
                            formFieldKey: ESettingTemplateTransferTargetFormFields.fieldTypeId,
                            formInstance: form,
                        }}
                    />
                </Form.Item>
                <Form.Item
                    validateTrigger="onFocuse"
                    label="Динамический SQL"
                    name={[field.name, ESettingTemplateTransferTargetFormFields.sourceFieldDynamicSQL]}
                    style={{width: 220}}
                    rules={[{
                        required: !checkWatcherFlag(
                            field.name,
                            ESettingTemplateTransferTargetFormFields.sourceFieldDynamicSQL,
                            EWatcherFieldFlag.isDisabled,
                        ),
                    }]}
                >
                    <LargeStringInput
                        disabled={checkWatcherFlag(field.name,
                            ESettingTemplateTransferTargetFormFields.sourceFieldDynamicSQL,
                            EWatcherFieldFlag.isDisabled)}
                        name={ESettingTemplateTransferTargetFormFields.sourceFieldDynamicSQL}
                        label="Динамический SQL"
                        placeholder="Динамический SQL"
                    />
                </Form.Item>
                <Form.Item
                    label="Константа"
                    name={[field.name, ESettingTemplateTransferTargetFormFields.sourceFieldConstant]}
                    style={{width: 220}}
                    validateTrigger="onFocuse"
                    rules={[{
                        required: !checkWatcherFlag(
                            field.name,
                            ESettingTemplateTransferTargetFormFields.sourceFieldConstant,
                            EWatcherFieldFlag.isDisabled,
                        ),
                    }]}
                >
                    <Input
                        autoComplete="off"
                        placeholder="Введите номер"
                        disabled={checkWatcherFlag(field.name,
                            ESettingTemplateTransferTargetFormFields.sourceFieldConstant,
                            EWatcherFieldFlag.isDisabled)}
                    />
                </Form.Item>
                <Form.Item
                    name={[field.name, ESettingTemplateTransferTargetFormFields.fieldTypeId]}
                    style={{width: 220}}
                    label="Тип поля"
                    rules={[{required: true}]}
                >
                    <CustomSelect
                        settings={{
                            showSearch: true,
                            placeholder: 'Выберите тип поля',
                            url: `valueLists/DATABASE_TABLE_COLUMNS?sublistCode=${
                                form?.getFieldValue(ESettingTemplateTransferTargetFormFields.TARGET_TABLE)
                                || documentUploadTemplate?.attribute2
                            }`,
                            labelPath: 'description',
                            isDisabled: checkWatcherFlag(field.name,
                                ESettingTemplateTransferTargetFormFields.fieldTypeId,
                                EWatcherFieldFlag.isDisabled),
                            valuePath: 'meaning',
                            formFieldKey: ESettingTemplateTransferTargetFormFields.fieldTypeId,
                            formInstance: form,
                        }}
                    />
                </Form.Item>
                <Form.Item
                    label={<>&nbsp;</>}
                    rules={[{
                        required: (form.getFieldValue([
                            SETTING_TEMPLATE_TRANSFER_TARGET_FORM_DATA_KEY,
                            field.name,
                            ESettingTemplateTransferTargetFormFields.fieldTypeId,
                        ]) !== SETTING_TEMPLATE_TRANSFER_TARGET_FIELD_TYPE
                      && !form.getFieldValue([
                          SETTING_TEMPLATE_TRANSFER_TARGET_FORM_DATA_KEY,
                          field.name,
                          ESettingTemplateTransferTargetFormFields.sourceFieldDynamicSQL,
                      ])),
                        message: 'Ошибка в настройке правил форматирования',
                    }]}
                >
                    <FormatSettingsModalOpener
                        form={form}
                        name={field.name}
                        isRequired={(form.getFieldValue([
                            SETTING_TEMPLATE_TRANSFER_TARGET_FORM_DATA_KEY,
                            field.name,
                            ESettingTemplateTransferTargetFormFields.fieldTypeId,
                        ]) !== SETTING_TEMPLATE_TRANSFER_TARGET_FIELD_TYPE
                      && !form.getFieldValue([
                          SETTING_TEMPLATE_TRANSFER_TARGET_FORM_DATA_KEY,
                          field.name,
                          ESettingTemplateTransferTargetFormFields.sourceFieldDynamicSQL,
                      ]))}
                        disabled={!formState?.isEditingForm}
                    />
                </Form.Item>
            </div>
        ))}
    </div>
);
